import { render, staticRenderFns } from "./PostComment.vue?vue&type=template&id=3c25db2e&scoped=true"
import script from "./PostComment.vue?vue&type=script&lang=js"
export * from "./PostComment.vue?vue&type=script&lang=js"
import style0 from "./PostComment.vue?vue&type=style&index=0&id=3c25db2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c25db2e",
  null
  
)

export default component.exports